export default __webpack_public_path__ + "static/media/1722.f132258e.png";